// @react
import React from 'react'
// @libraries
import Typography from '@material-ui/core/Typography'
// @components
import Button from '@bit/atd.web.button'
import Box from '@bit/atd.web.box'
import { useStyles } from './style'
import strings from 'lib/constants/strings'

enum MembershipAction {
  JOIN_NOW = 'join-now',
  LEARN_MORE = 'learn-more',
  SELECT_STUDENT = 'select-student',
  SELECT_SENIOR = 'select-senior',
  SELECT_PROFESSIONAL = 'select-professional',
}

type PropsType = {
  handleMemberOnClick?: (
    tier?: 'professional' | 'professional-plus' | 'enterprise',
    type?:
      | 'join-now'
      | 'learn-more'
      | 'select-student'
      | 'select-senior'
      | 'select-professional',
  ) => void
}

/**
 *
 * @param handleMemberOnClick
 * @constructor
 */
const PricingEnterprise = ({ handleMemberOnClick }: PropsType) => {
  const classes = useStyles()

  const handleOnClick = (membershipActionType?: MembershipAction) => {
    if (handleMemberOnClick)
      handleMemberOnClick('enterprise', membershipActionType)
  }

  return (
    <Box
      classNames={{
        root: classes.root,
      }}
    >
      <Typography className={classes.cardTitle} component="h3">
        {strings.ONBOARDING.MEMBERSHIP.ENTERPRISE.TITLE}
      </Typography>
      <Typography className={classes.cardSubTitle} component="p">
        {strings.ONBOARDING.MEMBERSHIP.ENTERPRISE.SUBTITLE}
      </Typography>
      <Typography className={classes.cardText} component="p">
        {strings.ONBOARDING.MEMBERSHIP.ENTERPRISE.DESCRIPTION}
      </Typography>
      <Button
        size="small"
        variant="secondary"
        onClick={() => handleOnClick(MembershipAction.LEARN_MORE)}
      >
        {strings.ONBOARDING.MEMBERSHIP.ENTERPRISE.BUTTON_ONE}
      </Button>
    </Box>
  )
}

export default PricingEnterprise
